import onReady from '../utils/onReady';


/**
 * Boilerplate class demonstrating basic construction.
 * You can expand from here, or find verbose examples in example.js.
 *
 * @param {HTMLElement} container
 * @constructor
 */
class AppartmentComplex {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        // Run initializing code once the DOM is ready.
        onReady(
            () => {
                this.init(container);
                this.checkForErrors();
            }
        );

        // You can put other initializer-code here if it isn't dependent on the DOM in any way.
    }


    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {

        this.dom = {
            container, // ES6 allows this syntax instead of writing "container: container"
            errors: container.querySelectorAll(".input-validation-error"),
            errormessage: container.querySelector(".errormessage")
        };

        // Put your other DOM-specific initializations here, and get your class moving!
    }

    checkForErrors() {
        if (this.dom.errors.length > 0) {
            // Errors..
            this.dom.errormessage.style.display = "block";
        }
    }


}


export default AppartmentComplex;